// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { TIMESHEET_FIELDS_VIEW_TYPE } from "./index"

export type StorageWriter = (value: Slice.TimesheetFieldsViewType) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(TIMESHEET_FIELDS_VIEW_TYPE, value.toString())
}

export const persistTimesheetFieldsViewType = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Slice.setTimesheetFieldsViewType.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.timesheetFieldsViewTypePersisted()),
        catchError(_ => of(Actions.timesheetFieldsViewTypePersistFailed())),
      )),
    )

export default persistTimesheetFieldsViewType(persist)
